export default "__VITE_ASSET__da29d47c__"